import { Injectable } from '@angular/core';
import { KeyValuePair } from '../../models/keyvaluepair.model';
import { CurrencyAmount } from '../../models/currencyamount.model';
import { OTA_Fee } from '../../models/ota_fee.model';
import { OTA_PricedEquip } from '../../models/ota_pricedequip.model';

export enum enumClientConfig {
    cconf_DefaultDateOutOffset = 1,
    cconf_DefaultTimeOut = 2,
    cconf_DefaultTimeIn = 3,
    cconf_DefaultDuration = 4,
    cconf_CoreImageURL = 5,
    cconf_VehicleImageFolder = 6,
    cconf_NonResConfirmationShowCosts = 7,
    cconf_OfferPayNow = 8,
    cconf_ExtraCostDisplayMode = 9,
    cconf_AvailVehImageHeight = 10,
    cconf_ExtrasImageFolder = 11,
    cconf_IconImageFolder = 12,
    cconf_AvailVehSmallImageWidth = 13,
    cconf_HasNotifications = 14,
    cconf_ShowDeliveryCollection = 15,
    cconf_ShowAuxVehicleInfo = 16,
    cconf_ShowSubscribe = 17,
    cconf_MandatoryDOB = 18,
    cconf_MandatoryDL = 19,
    cconf_ShowPromoTypes = 20,
    cconf_ShowDOB = 21,
    cconf_ShowDL = 22,
    cconf_MandatoryAddress = 23,
    cconf_ShowAddress = 24,
}

export enum enumUIConfig {
    uiconf_NavBarMainColour = 1,
    uiconf_NavBarDisabledColour = 2,
    uiconf_Font = 3,
    uiconf_GoogleFontLink = 4,
    uiconf_TextColour = 5,
    uiconf_InvalidTextColour = 6,
    uiconf_InvalidControlBorderColour = 7,
    uiconf_PageOuter = 8,
    uiconf_PageInner = 9,
    uiconf_ContainerBackgroundColour = 10,
    uiconf_ContainerBorderColour = 11,
    uiconf_ContainerBorderStyle = 12,
    uiconf_ContainerCornerRadius = 13,
    uiconf_InactiveTabColour = 14,
    uiconf_SubContainerBorderColour = 15,
    uiconf_SubContainerHeaderTextColour = 16,
    uiconf_SubContainerBackgroundColour = 17,
    uiconf_DividerLineColour = 18,
    uiconf_VehicleImageBorderStyle = 19,
    uiconf_RadioButtonColour = 20,
    uiconf_CommandButtonFont = 21,
    uiconf_CommandButtonRadius = 22,

    uiconf_PrimaryCommandButtonTextColour = 23,
    uiconf_PrimaryCommandButtonBackgroundColour = 24,
    uiconf_PrimaryCommandButtonBorderColour = 25,
    uiconf_PrimaryCommandButtonBorderStyle = 26,

    uiconf_SecondaryCommandButtonTextColour = 27,
    uiconf_SecondaryCommandButtonBackgroundColour = 28,
    uiconf_SecondaryCommandButtonBorderColour = 29,
    uiconf_SecondaryCommandButtonBorderStyle = 30,

    uiconf_VehPayNowButtonTextColour = 31,
    uiconf_VehPayNowButtonBackColour = 32,
    uiconf_VehPayNowButtonBorderColour = 33,
    uiconf_VehPayNowButtonBorderStyle = 34,
    uiconf_VehPayLaterButtonTextColour = 35,
    uiconf_VehPayLaterButtonBackColour = 36,
    uiconf_VehPayLaterButtonBorderColour = 37,
    uiconf_VehPayLaterButtonBorderStyle = 38,
    uiconf_VehRequestButtonTextColour = 39,
    uiconf_VehRequestButtonBackColour = 40,
    uiconf_VehRequestButtonBorderColour = 41,
    uiconf_VehRequestButtonBorderStyle = 42,
    uiconf_VehUnavailableButtonTextColour = 43,
    uiconf_VehUnavailableButtonBackColour = 44,
    uiconf_VehUnavailableButtonBorderColour = 45,
    uiconf_VehUnavailableButtonBorderStyle = 46,
    uiconf_HasMap = 47,
    uiconf_ValidationMode = 48,
    uiconf_MultiPageMode = 49,

    uiconf_CommandButtonTextSize = 50,
    uiconf_CommandButtonTextWeight = 51,

    uiconf_CheckboxTickColour = 52,
    uiconf_CheckboxTickedBackColour = 53,
    uiconf_CheckboxUntickedBackColour = 54,
    uiconf_CheckboxBorderColour = 55,

    uiconf_ExcessToCaption = 56,
    uiconf_PassengerCaption = 57,
    uiconf_SuitcaseCaption = 58,
    uiconf_AirConCaption = 59,

    uiconf_FirstNameCaption = 60,
    uiconf_LastNameCaption = 61,
    uiconf_EmailCaption = 62,
    uiconf_PhoneNumberCaption = 63,
    uiconf_DateOfBirthCaption = 64,

    uiconf_AgeAtPickUpCaption_Short = 65,
    uiconf_AgeAtPickUpCaption_Long = 66,

    uiconf_UnavailableCaption = 67,

    uiconf_AddressLineCaption = 68,
    uiconf_AddressCityCaption = 69,
    uiconf_AddressStateCaption = 70,
    uiconf_AddressZipCodeCaption = 71,
}

export enum enumValidationMode {
    valmode_Immediate = 0,
    valmode_OnPageSubmit = 1,
}

export enum enumMultiPageMode {
    mpmode_Tabs = 0,
    mpmode_Links = 1,
}

@Injectable()
export class ConfigDataService {
    public customCurrencies: KeyValuePair[];
    public clientConfigs: KeyValuePair[];
    public uiConfigs: KeyValuePair[];
    public vehicleTypes: KeyValuePair[];
    public rentalTimesOut: string[];
    public rentalTimesIn: string[];
    public ageRanges: KeyValuePair[];
    //public promoTypes: PromotionType[];
    public displayAdditionalChargeTypes: KeyValuePair[];
    public hideExtraChargeTypes: KeyValuePair[];

    //
    //constructor
    //
    constructor() {
    }

    //return the required ClientConfig value for the given key value
    public getClientConfig(configId: enumClientConfig, defaultValue: string = ""): string {
        var value: string = defaultValue;

        if (this.clientConfigs != null) {
            var prop = this.clientConfigs.find(x => x.value == configId);
            if (prop != null)
                value = prop.key;
        }

        return value;
    }

    //return the required UIConfig value for the given key value
    public getUIConfig(configId: enumUIConfig, defaultValue: string = ""): string {
        var value: string = defaultValue;

        if (this.uiConfigs != null) {
            var prop = this.uiConfigs.find(x => x.value == configId);
            if (prop != null)
                value = prop.key;
        }

        return value;
    }

    //format the given CurrencyAmount (which includes the AMount, and the CurrencyCode, and maybe the Units)
    //apply a custom currency symbol if required (eg. Australian dollor usually get formateed with A$, but we may want just $)
    public formatCurrencyAmount(currAmnt: CurrencyAmount, showUnits: boolean = false): string {
        var locale; //leave unassigned
        
        if (currAmnt.currencyCode.length == 0) {
            return currAmnt.amount.toString();
        }
        else {
            var formattedAmount = new Intl.NumberFormat(locale, { style: 'currency', currency: currAmnt.currencyCode }).format(currAmnt.amount);

            if (this.customCurrencies != null) {
                //check if we need to reformat the currency amount with a custom symbol
                let customCurrs: KeyValuePair[] = this.customCurrencies.filter(kvp => (kvp.key == currAmnt.currencyCode));

                //reformat with the custom symbol
                if (customCurrs.length > 0) {
                    formattedAmount = new Intl.NumberFormat(locale, { style: 'currency', currency: currAmnt.currencyCode, currencyDisplay: 'code' }).format(currAmnt.amount);
                    formattedAmount = formattedAmount.replace(currAmnt.currencyCode, customCurrs[0].value);
                    formattedAmount = formattedAmount.replace(/\s/g, "");   //remove white space
                }
            }

            if (showUnits)
                formattedAmount = formattedAmount + "/" + currAmnt.unitName.toLowerCase();

            return formattedAmount;
        }
    }

    //return True if the given Fee is in the list of DisplayAdditionChargeTypes
    public showAdditionalFee(fee: OTA_Fee): boolean {
        let showFee: boolean = false;

        if (this.displayAdditionalChargeTypes != null) {
            var displayFee = this.displayAdditionalChargeTypes.find(kvp => (kvp.key == fee.purpose));
            showFee = (displayFee != null);
        }

        return showFee;
    }

    //return True if the given Fee is in the list of HideExtraChargeTypes
    public hideExtra(eq: OTA_PricedEquip): boolean {
        let hideExtraEq: boolean = false;

        if (this.hideExtraChargeTypes != null) {
            var hideEq = this.hideExtraChargeTypes.find(kvp => (kvp.key == eq.equipment.equipType));
            hideExtraEq = (hideEq != null);
        }

        return hideExtraEq;
    }
}